import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import { cssVars } from '@/styles/Themes/cssVars';
import { radius } from '@/styles/Themes/Metrics';

export const Wrapper = styled.div`
    background-color: ${cssVars.bg_ash_dark2};
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Full.normal.regular}
    border-radius: ${radius.small};
    padding: 20px 16px;
    display: flex;
    margin-bottom: 25px;
    gap: 4px;

    *:first-child {
        min-width: 24px;
    }
`;

export const Title = styled.div`
    ${Text.Full.large.semibold}
`;
